import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  Alert,
  useTheme,
  useMediaQuery,
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  Typography,
  AppBar,
  Toolbar,
  Divider,
} from "@mui/material";
import { OpenInNew, TableChart, LocalShipping, ShoppingBag, Event, Email } from "@mui/icons-material";
import TablesSection from "../../components/PagesComponents/PosSection/PosPageTaps/TablesSectionTap/MobileTablesSection";
import DeliverySection from "../../components/PagesComponents/PosSection/PosPageTaps/DeliverySectionTap/MobileDeliverySection";
import TakeawaySection from "../../components/PagesComponents/PosSection/PosPageTaps/TakeawaySectionTap/MobileTakeawaySection";
import ReservationSection from "../../components/PagesComponents/PosSection/PosPageTaps/ReservationSectionTap/ReservationSection";
import { useFeatures } from "../../context/PermissionsAndFeatures/FeaturesContext";


const POS = ({ isSidebarOpen }) => {
  const features = useFeatures();

  const resolveFeature = (featObj, key) => {
    if (featObj == null) return null;
    try {
      if (typeof featObj === "function") return featObj(key);
      if (typeof featObj.isEnabled === "function") return featObj.isEnabled(key);
      if (typeof featObj.hasFeature === "function") return featObj.hasFeature(key);
      if (typeof featObj.get === "function") return featObj.get(key);
      if (key in featObj) return featObj[key];
    } catch (e) {
      return null;
    }
    return null;
  };

  const isTakeawayEnabled = resolveFeature(features, "operation_takeaway") !== false;
  const isDeliveryEnabled = resolveFeature(features, "operation_delivery") !== false;
  const isTableEnabled = resolveFeature(features, "operation_table") !== false;

  const [tabIndex, setTabIndex] = useState(() => {
    const savedTabIndex = localStorage.getItem("posTabIndex");
    return savedTabIndex ? parseInt(savedTabIndex, 10) : 0;
  });

  useEffect(() => {
    localStorage.setItem("posTabIndex", tabIndex);
  }, [tabIndex]);

  const tabs = [
    { id: "tables", label: "الطاولات", url: "/tables", icon: <TableChart /> },
    { id: "delivery", label: "الدليفري", url: "/delivery", icon: <LocalShipping /> },
    { id: "takeaway", label: "التيك أواي", url: "/takeaway", icon: <ShoppingBag /> },
    { id: "reservation", label: "الحجز", url: "/reservation", icon: <Event /> },
  ];

  useEffect(() => {
    if (tabIndex >= tabs.length) {
      setTabIndex(0);
    }
  }, [tabs.length]);

  const handleChange = (index) => {
    setTabIndex(index);
  };

  const openInNewTab = () => {
    const tab = tabs[tabIndex];
    if (!tab) return;

    if (tab.id === "tables" && !isTableEnabled) {
      const win = window.open("", "_blank");
      if (!win) return;
      win.document.write(`
        <html>
          <head><title>الطاولات - غير مفعّل</title></head>
          <body style="font-family: sans-serif; display:flex; align-items:center; justify-content:center; height:100vh; background:#fff;">
            <div style="max-width:620px; padding:20px; border-radius:8px; box-shadow:0 4px 18px rgba(0,0,0,0.06); text-align:center;">
              <h2 style="margin-bottom:8px;">🚫 خدمة الطاولات غير مفعّلة</h2>
              <p style="color:#333; line-height:1.5;">يُرجى التواصل مع فريق الدعم الفني لتفعيل ميزة الطاولات.</p>
            </div>
          </body>
        </html>
      `);
      win.document.close();
      return;
    }

    if (tab.id === "takeaway" && !isTakeawayEnabled) {
      const win = window.open("", "_blank");
      if (!win) return;
      win.document.write(`
        <html>
          <head><title>التيك أواي - غير مفعّل</title></head>
          <body style="font-family: sans-serif; display:flex; align-items:center; justify-content:center; height:100vh; background:#fff;">
            <div style="max-width:620px; padding:20px; border-radius:8px; box-shadow:0 4px 18px rgba(0,0,0,0.06); text-align:center;">
              <h2 style="margin-bottom:8px;">🚫 خدمة التيك أواي غير مفعّلة</h2>
              <p style="color:#333; line-height:1.5;">يُرجى التواصل مع فريق الدعم الفني لتفعيل ميزة التيك أواي.</p>
            </div>
          </body>
        </html>
      `);
      win.document.close();
      return;
    }

    if (tab.id === "delivery" && !isDeliveryEnabled) {
      const win = window.open("", "_blank");
      if (!win) return;
      win.document.write(`
        <html>
          <head><title>الدليفري - غير مفعّل</title></head>
          <body style="font-family: sans-serif; display:flex; align-items:center; justify-content:center; height:100vh; background:#fff;">
            <div style="max-width:620px; padding:20px; border-radius:8px; box-shadow:0 4px 18px rgba(0,0,0,0.06); text-align:center;">
              <h2 style="margin-bottom:8px;">🚫 خدمة الدليفري غير مفعّلة</h2>
              <p style="color:#333; line-height:1.5;">يُرجى التواصل مع فريق الدعم الفني لتفعيل ميزة الدليفري.</p>
            </div>
          </body>
        </html>
      `);
      win.document.close();
      return;
    }

    window.open(tab.url, "_blank");
  };

  const renderDisabledAlert = (message) => (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 220, px: 2 }}>
      <Alert
        severity="warning"
        sx={{ width: "100%", textAlign: "center", fontSize: "14px" }}
        action={
          <Button
            size="small"
            startIcon={<Email />}
            href={`mailto:support@yourdomain.com?subject=تفعيل%20ميزة&body=${encodeURIComponent(message)}`}
          >
            تواصل مع الدعم
          </Button>
        }
      >
        {message}
      </Alert>
    </Box>
  );

  const renderTabContent = (tabId) => {
    switch (tabId) {
      case "tables":
        if (!isTableEnabled) {
          return renderDisabledAlert("🚫 خدمة الطاولات غير مفعّلة حالياً. يرجى التواصل مع فريق الدعم الفني لتفعيل الميزة.");
        }
        return <TablesSection />;
      case "delivery":
        if (!isDeliveryEnabled) {
          return renderDisabledAlert("🚫 خدمة الدليفري غير مفعّلة حالياً. يرجى التواصل مع فريق الدعم الفني لتفعيل الميزة.");
        }
        return <DeliverySection />;
      case "takeaway":
        if (!isTakeawayEnabled) {
          return renderDisabledAlert("🚫 خدمة التيك أواي غير مفعّلة حالياً. يرجى التواصل مع فريق الدعم الفني لتفعيل الميزة.");
        }
        return <TakeawaySection />;
      case "reservation":
        return <ReservationSection />;
      default:
        return null;
    }
  };

  // NEW: show component only on mobile
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  if (!isMobile) return null;

  // calculate content area height to avoid overlap with appbar & bottom nav
  const APPBAR_HEIGHT = 56;
  const BOTTOM_NAV_HEIGHT = 68;
  const contentMinHeight = `calc(100vh - ${APPBAR_HEIGHT + BOTTOM_NAV_HEIGHT + 24}px)`;

  return (
    <Box dir="rtl" sx={{ width: "100%", p: 0, bgcolor: "#fff", minHeight: "100vh", pb: `${BOTTOM_NAV_HEIGHT + 12}px` }}>
      {/* Top App Bar */}
      <AppBar position="sticky" color="default" elevation={3} sx={{ bgcolor: "#fff" }}>
        <Toolbar sx={{ minHeight: APPBAR_HEIGHT }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 800, color: "#333" }}>
              {tabs[tabIndex]?.label || "نقطة البيع"}
            </Typography>
            <Typography variant="caption" sx={{ color: "#666", display: "block" }}>
              واجهة موبايل مُحسّنة — اللمس أسهل وأسرع
            </Typography>
          </Box>

          <IconButton
            aria-label="فتح في تبويب جديد"
            onClick={openInNewTab}
            sx={{ bgcolor: "#EA7C69", color: "#fff", ml: 1 }}
            size="large"
          >
            <OpenInNew />
          </IconButton>
        </Toolbar>
        <Divider />
        {/* Horizontal segmented tabs (scrollable) */}
        <Box sx={{ display: "flex", gap: 1, px: 1, py: 1, overflowX: "auto", bgcolor: "#fff" }}>
          {tabs.map((tab, index) => (
            <Button
              key={tab.id}
              onClick={() => handleChange(index)}
              startIcon={tab.icon}
              aria-pressed={tabIndex === index}
              sx={{
                flex: "0 0 auto",
                display: "flex",
                alignItems: "center",
                gap: 1,
                backgroundColor: tabIndex === index ? "#814C3B" : "#F6CFC6",
                color: tabIndex === index ? "#fff" : "#6B2F21",
                fontSize: "14px",
                fontWeight: 700,
                borderRadius: 2,
                padding: "10px 14px",
                minWidth: 120,
                boxShadow: "none",
                textTransform: "none",
              }}
            >
              <Box sx={{ display: { xs: "inline", sm: "inline" } }}>{tab.label}</Box>
            </Button>
          ))}
        </Box>
      </AppBar>

      {/* main content area */}
      <Box sx={{ px: 1, pt: 1, minHeight: contentMinHeight }}>{renderTabContent(tabs[tabIndex]?.id)}</Box>

      {/* sticky bottom navigation for quick access */}
      <Paper
        elevation={8}
        sx={{
          position: "fixed",
          bottom: 12,
          left: "50%",
          transform: "translateX(-50%)",
          width: "calc(100% - 24px)",
          maxWidth: 720,
          borderRadius: 12,
          overflow: "hidden",
          height: BOTTOM_NAV_HEIGHT,
        }}
      >
        <BottomNavigation
          showLabels
          value={tabIndex}
          onChange={(e, newValue) => handleChange(newValue)}
          sx={{
            height: "100%",
            "& .MuiBottomNavigationAction-root": {
              minWidth: 0,
            },
            "& .Mui-selected": {
              color: "#814C3B",
            },
          }}
        >
          <BottomNavigationAction label="طاولات" icon={<TableChart />} />
          <BottomNavigationAction label="دليفري" icon={<LocalShipping />} />
          <BottomNavigationAction label="تيك أواي" icon={<ShoppingBag />} />
          <BottomNavigationAction label="حجز" icon={<Event />} />
        </BottomNavigation>
      </Paper>

      <style>
        {`
          @media (max-width: 420px) {
            body { font-size: 14px; }
          }
        `}
      </style>
    </Box>
  );
};

export default POS;
